export default __webpack_public_path__ + "static/media/pic3.e621a58d.jpg";